import { Action } from 'redux';

import { RouterErrorHide, RouterErrorShow } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { RouterErrorType } from '../../bootstrap/redux/state/RouterErrorType';

export interface ShowRouterErrorAction extends Action {
  errorType: RouterErrorType;
  redirectSiteUrlName: string;
}

export function showRouterError(errorType: RouterErrorType, redirectSiteUrlName?: string): ShowRouterErrorAction {
  return {
    type: RouterErrorShow,
    errorType,
    redirectSiteUrlName: redirectSiteUrlName || ''
  };
}

export const isShowRouterErrorAction = isActionFactory<ShowRouterErrorAction>(RouterErrorShow);

export interface HideRouterErrorAction extends Action {}

export function hideRouterError(): HideRouterErrorAction {
  return {
    type: RouterErrorHide
  };
}

export const isHideRouterErrorAction = isActionFactory<HideRouterErrorAction>(RouterErrorHide);
